exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#appDrawer{overflow:hidden}#appDrawer .drawer-menu--scroll{height:calc(100vh - 64px);overflow:auto}", ""]);

// exports
